import React from 'react';
import {
  Form,
  Input,
  Select,
  InputNumber,
  DatePicker,
  Radio,
  Button,
  Card,
  Space,
} from 'antd';
import ThemeDebugger from '../components/debug/ThemeDebugger';

const { TextArea } = Input;
const { Option } = Select;

const ThemeTestPage: React.FC = () => {
  const [form] = Form.useForm();

  return (
    <div style={{ padding: '24px', background: '#f5f5f5', minHeight: '100vh' }}>
      <div style={{ maxWidth: '800px', margin: '0 auto' }}>
        <ThemeDebugger />

        <Card title="🎨 Ant Design 主题测试页面">
          <div style={{ marginBottom: '24px' }}>
            <h3>当前主题测试</h3>
            <p>这个页面用于测试Ant Design组件是否正确应用了翡翠绿主题。</p>
            <p>
              <strong>预期效果：</strong>所有输入组件在焦点时应显示翡翠绿边框
              (#10b981) 和外发光效果。
            </p>
          </div>

          <Form form={form} layout="vertical">
            <Space direction="vertical" style={{ width: '100%' }} size="large">
              <div>
                <h4>1. Input 输入框</h4>
                <Form.Item label="普通输入框" name="input1">
                  <Input placeholder="请输入文本，观察焦点时的边框颜色" />
                </Form.Item>
              </div>

              <div>
                <h4>2. TextArea 文本域</h4>
                <Form.Item label="多行文本" name="textarea1">
                  <TextArea
                    rows={3}
                    placeholder="请输入多行文本，观察焦点时的边框颜色"
                  />
                </Form.Item>
              </div>

              <div>
                <h4>3. Select 选择器</h4>
                <Form.Item label="下拉选择" name="select1">
                  <Select placeholder="请选择选项，观察焦点时的边框颜色">
                    <Option value="option1">选项1</Option>
                    <Option value="option2">选项2</Option>
                    <Option value="option3">选项3</Option>
                  </Select>
                </Form.Item>
              </div>

              <div>
                <h4>4. InputNumber 数字输入框</h4>
                <Form.Item label="数字输入" name="number1">
                  <InputNumber
                    style={{ width: '100%' }}
                    placeholder="请输入数字，观察焦点时的边框颜色"
                  />
                </Form.Item>
              </div>

              <div>
                <h4>5. DatePicker 日期选择器</h4>
                <Form.Item label="日期选择" name="date1">
                  <DatePicker
                    style={{ width: '100%' }}
                    placeholder="请选择日期，观察焦点时的边框颜色"
                  />
                </Form.Item>
              </div>

              <div>
                <h4>6. Radio.Group 单选框组</h4>
                <Form.Item label="单选选择" name="radio1">
                  <Radio.Group>
                    <Radio value="a">选项A - 观察选中时的颜色</Radio>
                    <Radio value="b">选项B - 观察选中时的颜色</Radio>
                    <Radio value="c">选项C - 观察选中时的颜色</Radio>
                  </Radio.Group>
                </Form.Item>
              </div>

              <div>
                <Button type="primary" htmlType="submit">
                  提交测试 - 观察按钮的主色调
                </Button>
              </div>
            </Space>
          </Form>

          <div
            style={{
              marginTop: '32px',
              padding: '16px',
              background: '#f0f0f0',
              borderRadius: '8px',
            }}
          >
            <h4>🎯 测试说明 - 完整的边框颜色状态</h4>
            <ul>
              <li>
                <strong>默认状态边框：</strong> #6ee7b7 (翡翠绿-300)
              </li>
              <li>
                <strong>悬停状态边框：</strong> #34d399 (翡翠绿-400)
              </li>
              <li>
                <strong>焦点状态边框：</strong> #10b981 (翡翠绿-500) + 外发光
              </li>
              <li>
                <strong>焦点外发光：</strong> 0 0 0 2px rgba(16, 185, 129, 0.2)
              </li>
              <li>
                <strong>测试方法：</strong>
                <ol style={{ marginTop: '8px' }}>
                  <li>观察输入框默认状态（应该是浅翡翠绿边框）</li>
                  <li>鼠标悬停（边框变深一些）</li>
                  <li>点击获得焦点（边框最深 + 外发光效果）</li>
                </ol>
              </li>
            </ul>
            <div
              style={{
                marginTop: '16px',
                padding: '12px',
                background: '#e8f5e8',
                borderRadius: '6px',
                border: '1px solid #6ee7b7',
              }}
            >
              <strong>✅ 预期效果：</strong>{' '}
              现在所有输入组件在任何状态下都应该显示翡翠绿系列的边框颜色，不再有黑色边框！
            </div>
          </div>
        </Card>
      </div>
    </div>
  );
};

export default ThemeTestPage;
